export default __webpack_public_path__ + "static/media/Furniture2.dcd67bdb.png";